import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/lits.json";
import fr from "@/locales/fr/puzzle-types/lits.json";

export const LITS_NS = "puzzle-types/lits";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerLitsTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", LITS_NS)) i18n.addResourceBundle("en", LITS_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", LITS_NS)) i18n.addResourceBundle("fr", LITS_NS, fr, true, true);
}
